/* eslint-disable react/function-component-definition */
import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

// Components
import HeroAlt from './HeroAlt'

const HeroProjects = () => {
  const {
    wpPage: { pageProjects: { heroprojects } }
  } = useStaticQuery(graphql`
    {
      wpPage(databaseId: { eq: 8 }) {
        pageProjects {
          heroprojects {
            title
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 1920, quality: 100)
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <HeroAlt className="mb-5 z-index-2" src={heroprojects.image} small>
      {heroprojects.title}
    </HeroAlt>
  )
}

export default HeroProjects